import {TrackingPageTypeWithId} from '@aboutyou/legacy-tracking-sdk';
import React from 'react';
import {Drop} from '../../../grpc_client/grips/protos/shared/drop';
import {SharedPageTrackingContextProvider} from '../../../tracking/context/PageTrackingContext';
import TrackContentPageView from '../../../tracking/trackerComponents/TrackContentPageView';
import {ActiveDrops} from '../../../ui/Drops/components/ActiveDrop/ActiveDrops';
import DropBanner from '../../../ui/Drops/components/Banner/Banner';
import {OverviewPageContainer} from '../../../ui/Drops/components/DropOverviewStyles';
import {PastDrops} from '../../../ui/Drops/components/PastDrop/PastDrops';
import {UpcomingDrops} from '../../../ui/Drops/components/UpcomingDrop/UpcomingDrops';
import useDropTypeFromPath from '../../../utils/hooks/useDropTypeFromPath';
import {DropSubscriptionsProvider} from '../context/DropSubscriptionsProvider';
import {DropCasesEnum, DropsOverview} from '../types';
import {getDropsByType} from '../utils/helpers';
import {DropsSubscribeModalWrapper} from './DropsSubscribeModalWrapper';
import {useAreDropsSubscriptionsForUser} from './useAreDropsSubscriptionsForUser';

const DropsOverviewPage: React.FC<DropsOverview> = ({
  dropsOverviewPage: {pageInformation, sections},
  trackingCustomer,
}) => {
  const activeDrops = getDropsByType(
    sections,
    DropCasesEnum.ACTIVE_DROPS,
  ) as Drop[];
  const upcomingDrops = getDropsByType(
    sections,
    DropCasesEnum.UPCOMING_DROPS,
  ) as Drop[];
  const pastDrops = getDropsByType(
    sections,
    DropCasesEnum.PAST_DROPS,
  ) as Drop[];

  useAreDropsSubscriptionsForUser();

  const dropType = useDropTypeFromPath();
  return (
    <SharedPageTrackingContextProvider
      type={TrackingPageTypeWithId.DropOverview}
      path={`/d/${dropType}/overview`}
      search=""
      id={1}
    >
      <TrackContentPageView trackingCustomer={trackingCustomer ?? null}>
        <DropBanner
          imageHash={pageInformation?.imageHash}
          title={pageInformation?.usps?.uspTitle}
          usps={pageInformation?.usps?.usps}
        />
        <OverviewPageContainer>
          <ActiveDrops activeDrops={activeDrops} />

          <UpcomingDrops upcomingDrops={upcomingDrops} />

          <PastDrops pastDrops={pastDrops} />
        </OverviewPageContainer>
        <DropsSubscribeModalWrapper />
      </TrackContentPageView>
    </SharedPageTrackingContextProvider>
  );
};

const DropsOverviewPageWrapper: React.FC<DropsOverview> = props => {
  return (
    <DropSubscriptionsProvider>
      <DropsOverviewPage {...props} />
    </DropSubscriptionsProvider>
  );
};

export default DropsOverviewPageWrapper;
